import { QueryClient } from "@tanstack/react-query";

import { Time } from "@iluvatar/global/src/utilities/time";

/**
 * This query client is used for non network requests or actions that do not require caching of data
 */
export const asyncActionsClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      networkMode: "always",
    },
  },
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 25 * Time.mins,
      staleTime: 5 * Time.mins,
      refetchInterval: false,
      refetchOnMount(q) {
        return q.isStale();
      },
      refetchOnWindowFocus: true,
      retryDelay: 1000,
      retryOnMount: true,
      retry(failureCount, error) {
        if (failureCount > 2) {
          // oxlint-disable-next-line no-console
          console.error(error);
          return false;
        }
        return true;
      },
      networkMode: "online",
    },
  },
});

/** Account-specific results are kept in memory, never in a shared localStorage cache. */
export function clearQueryCaches(clearActions = true) {
  queryClient.clear();
  if (clearActions) {
    asyncActionsClient.clear();
  }
}
